/** Merge ATS row fields from GET /candidates profile API (displayEmail, resumeLink, etc.). */

export function mergeApplicationCandidateFields(app, candidate) {
  if (!app) return app;
  if (!candidate) return app;

  const email = (candidate.displayEmail || candidate.contact?.email || '').trim();
  const phone = (candidate.displayPhone || candidate.contact?.phone || '').trim();
  const resumeLink = candidate.resumeLink || candidate.resume || null;
  const hasResume = Boolean(
    candidate.hasResume || resumeLink || candidate.resumeFile?.path
  );
  const resumeFileName = (
    candidate.resumeFileName ||
    candidate.resumeOriginalName ||
    ''
  ).trim();

  return {
    ...app,
    candidateEmail: email || app.candidateEmail || '',
    candidatePhone: phone || app.candidatePhone || '',
    candidateResumeLink: resumeLink || app.candidateResumeLink || null,
    candidateHasResume: hasResume || Boolean(app.candidateHasResume),
    candidateResumeFileName: resumeFileName || app.candidateResumeFileName || '',
    candidatePhoto:
      candidate.photo || candidate.photoUrl || app.candidatePhoto || '',
    candidateProfileCompletionPercent:
      candidate.profileCompletionPercent ?? app.candidateProfileCompletionPercent ?? null
  };
}

export function mergeApplicationsWithCandidates(applications, candidates) {
  if (!applications?.length) return applications || [];
  if (!candidates?.length) return applications;
  const byId = new Map(candidates.map(c => [c.id, c]));
  return applications.map(app =>
    mergeApplicationCandidateFields(app, byId.get(app.candidateId))
  );
}
